/**
 * @fileoverview Hook Actions Layer para CustomerOrderItemMC: expone handlers de negocio (ver detalle, abrir modal edición).
 * @module useCustomerOrderItemActions
 * @category Hook - Actions Layer
 * @since 1.0.0
 * @version 1.0.0
 */
import { useCallback } from 'react';

export default function useCustomerOrderItemActions({ order, openModalOrder }) {

  /**
   * Abre el detalle de la orden en una nueva pestaña.
   * @function viewOrderDetail
   * @memberof useCustomerOrderItemActions
   */
  const viewOrderDetail = useCallback(() => {
    const orderDetailUrl = `/retailers/${ENV.SLUG}/orders/${order.web_id}`;
    window.open(orderDetailUrl, '_blank');
  }, [order.web_id]);

  /**
   * Abre el modal de edición de orden.
   * @function handleOpenEditOrderModal
   * @memberof useCustomerOrderItemActions
   */
  const handleOpenEditOrderModal = useCallback(() => {
    const data = { selectedOrder: order };
    openModalOrder(data);
  }, [order, openModalOrder]);

  return { viewOrderDetail, handleOpenEditOrderModal };
}
